import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMxFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53682)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M16.6662 41.3788H0.861621C0.385547 41.3788 -0.000488281 40.9928 -0.000488281 40.5167V9.48223C-0.000488281 9.00615 0.385547 8.62012 0.861621 8.62012H16.6662V41.3788Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33.334 8.62061H16.667V41.3794H33.334V8.62061Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1376 41.3792H33.333V8.62061H49.1376C49.6137 8.62061 49.9997 9.00664 49.9997 9.48271V40.5172C49.9997 40.9934 49.6137 41.3792 49.1376 41.3792Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.4868 25.771L25 26.5145V27.258H25.7435L26.4868 25.771Z",
					fill: "#FFD250"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.9982 29.1161C24.7928 29.1161 24.6265 28.9498 24.6265 28.7443V27.2575C24.6265 27.052 24.7928 26.8857 24.9982 26.8857C25.2037 26.8857 25.37 27.052 25.37 27.2575V28.7443C25.37 28.9498 25.2037 29.1161 24.9982 29.1161Z",
					fill: "#00C3A0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.9984 27.6295C23.5384 27.6295 22.1285 27.0661 21.0283 26.0431C20.878 25.9034 20.8693 25.6681 21.009 25.5179C21.1498 25.368 21.3848 25.36 21.5342 25.4986C22.4965 26.3934 23.7268 26.886 24.9983 26.886C26.2699 26.886 27.5002 26.3934 28.4625 25.4986C28.6124 25.3596 28.8473 25.3673 28.9877 25.5179C29.1274 25.6682 29.1187 25.9035 28.9684 26.0431C27.8684 27.0662 26.4585 27.6295 24.9984 27.6295Z",
					fill: "#00C3A0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.9996 29.1162C24.0467 29.1162 23.1236 28.8378 22.3301 28.3107L22.7417 27.6914C24.0834 28.5829 25.9158 28.5829 27.2574 27.6914L27.669 28.3107C26.8756 28.8379 25.9525 29.1162 24.9996 29.1162Z",
					fill: "#00AADC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.4109 24.0981L23.5901 25.3684L23.4507 25.7864L25.5881 25.2908L24.4109 24.0981Z",
					fill: "#732D37"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.725 26.1947C21.7424 26.1947 20.5629 25.3678 20.25 23.5252L20.9833 23.4011C21.2433 24.9333 22.1858 25.4523 22.7519 25.451C22.9254 25.4462 23.1064 25.3863 23.1207 25.2637C23.1374 25.117 23.1414 25.0822 22.7526 24.9508C22.5413 24.8792 22.3018 24.7983 22.1337 24.606C21.4537 23.8295 22.3743 23.0077 22.8166 22.6128C22.8946 22.5431 22.927 22.4839 22.9187 22.4614C22.8943 22.3979 22.7484 22.3018 22.584 22.3018C22.1117 22.3018 21.7534 22.035 21.6493 21.6059C21.5411 21.1615 21.7455 20.6933 22.1347 20.4922L22.476 21.1528C22.3848 21.2 22.3486 21.3343 22.3718 21.4302C22.3809 21.4687 22.403 21.5583 22.5842 21.5583C23.0394 21.5583 23.4725 21.827 23.6133 22.1965C23.6735 22.354 23.7643 22.7635 23.312 23.1675C22.8237 23.6035 22.5315 23.9316 22.6935 24.1164C22.7301 24.1581 22.8873 24.2115 22.9911 24.2464C23.3258 24.3597 23.9487 24.5702 23.8595 25.3488C23.8035 25.8385 23.3665 26.1782 22.7727 26.1943C22.7566 26.1943 22.7406 26.1947 22.725 26.1947Z",
					fill: "#AAD264"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.7435 22.0537C25.7435 22.0537 26.4869 20.5669 25 19.8234C25 19.8234 30.204 19.08 29.4605 25.7709L29.4603 25.7706C28.9724 25.3802 28.2479 24.6669 27.9893 24.0981L25.7435 22.797V22.0537Z",
					fill: "#874150"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25 23.5405L28.7171 25.7708C28.7171 25.7708 28.7171 25.7708 27.2303 26.5143L25 24.2841V23.5405Z",
					fill: "#732D37"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.5127 21.3103C23.9232 21.3103 24.2562 21.6432 24.2562 22.0537L24.2554 22.0545C23.8118 22.498 23.702 23.1755 23.9824 23.7365L24.1504 24.0726C24.2204 24.2126 24.3126 24.3405 24.4233 24.4513L26.4865 26.5145V25.487C26.4865 24.207 26.1886 22.9446 25.6161 21.7998C25.2383 21.0442 24.466 20.5669 23.6213 20.5669H23.5128V21.3104H23.5127V21.3103Z",
					fill: "#783C46"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.5135 20.5669L22.77 21.3104V22.0538C22.77 22.0538 23.6544 21.6055 23.9524 21.4626C24.1607 21.3628 24.1228 21.1268 24.0033 21.013C23.9103 20.9245 23.5135 20.5669 23.5135 20.5669Z",
					fill: "#FFD250"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.9998 30.6033C21.5153 30.6033 18.6807 27.7687 18.6807 24.2842H19.4241C19.4241 27.3589 21.9252 29.86 24.9999 29.86C28.0746 29.86 30.5757 27.3589 30.5757 24.2842H31.3191C31.3189 27.7687 28.4843 30.6033 24.9998 30.6033Z",
					fill: "#AAD264"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.4659 26.9943C19.7445 26.9943 19.9704 26.7685 19.9704 26.4898C19.9704 26.2112 19.7445 25.9854 19.4659 25.9854C19.1873 25.9854 18.9614 26.2112 18.9614 26.4898C18.9614 26.7685 19.1873 26.9943 19.4659 26.9943Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.5807 28.7756C20.8593 28.7756 21.0852 28.5497 21.0852 28.2711C21.0852 27.9925 20.8593 27.7666 20.5807 27.7666C20.302 27.7666 20.0762 27.9925 20.0762 28.2711C20.0762 28.5497 20.302 28.7756 20.5807 28.7756Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.3927 30.1223C22.6713 30.1223 22.8972 29.8964 22.8972 29.6178C22.8972 29.3391 22.6713 29.1133 22.3927 29.1133C22.1141 29.1133 21.8882 29.3391 21.8882 29.6178C21.8882 29.8964 22.1141 30.1223 22.3927 30.1223Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.5904 26.9943C30.8691 26.9943 31.0949 26.7685 31.0949 26.4898C31.0949 26.2112 30.8691 25.9854 30.5904 25.9854C30.3118 25.9854 30.0859 26.2112 30.0859 26.4898C30.0859 26.7685 30.3118 26.9943 30.5904 26.9943Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29.4737 28.7756C29.7524 28.7756 29.9782 28.5497 29.9782 28.2711C29.9782 27.9925 29.7524 27.7666 29.4737 27.7666C29.1951 27.7666 28.9692 27.9925 28.9692 28.2711C28.9692 28.5497 29.1951 28.7756 29.4737 28.7756Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.6622 30.1223C27.9408 30.1223 28.1667 29.8964 28.1667 29.6178C28.1667 29.3391 27.9408 29.1133 27.6622 29.1133C27.3836 29.1133 27.1577 29.3391 27.1577 29.6178C27.1577 29.8964 27.3836 30.1223 27.6622 30.1223Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.3717 29.4879H24.6282C24.2177 29.4879 23.8848 29.155 23.8848 28.7444C23.8848 28.3339 24.2177 28.001 24.6282 28.001H25.3717C25.7822 28.001 26.1151 28.3339 26.1151 28.7444C26.1151 29.1551 25.7822 29.4879 25.3717 29.4879Z",
					fill: "#FFB478"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.9893 24.098C28.2371 24.8259 28.7637 25.492 29.4603 25.7705L29.4605 25.7708C30.204 19.08 25 19.8234 25 19.8234C28.7171 19.8234 27.9893 24.098 27.9893 24.098Z",
					fill: "#9B4B5A"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53682",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgMxFlag);
export { ForwardRef as ReactComponent };
